import {AnimatePresence, motion} from 'framer-motion';
import { useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { faAngleLeft, faAngleRight, faGlobe, faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import '../CSS/projectModal.scss';
import { modalVariant, textVariantLeft, textVariantRight, imageSliderVariant } from '../Variants/variants';

const ProjectModal = ({project, closeModal}) =>{
    const [page, setPage] = useState(0);
    const [direction, setDirection] = useState(0);

    const wrap = (min, max, num) =>{
        if(num > max){
            return min;
        }
        else return num;
    }

    let imageIndex = wrap(0, project.secImg.length, page)

    const next = () =>{
        setPage(page === project.secImg.length - 1 ? 0 : page + 1)
        setDirection(1)
    }

    const prev = () =>{
        setPage(page === 0 ? project.secImg.length - 1 : page - 1)
        setDirection(-1)
    }
    
    const createMarkup = (letter) =>{
        return {__html: letter}
    }

    const createP = (string) =>{
        return <motion.p style={{fontSize: "1.2rem"}}
            dangerouslySetInnerHTML={createMarkup(string)}
            variants={textVariantLeft}
            ></motion.p>
    }

    const createDesc = (string) =>{
        return <motion.p 
            dangerouslySetInnerHTML={createMarkup(string)}
            >
            </motion.p>
    }
    
    return(
        <motion.div 
        className='project-modal'
        onClick={(e) => e.stopPropagation()}
        variants={modalVariant}
        initial="initial"
        animate="animate"
        exit="initial">
            <motion.button whileHover={{scale: 1.1}} className="modal-close" onClick={() => closeModal()}>
                <FontAwesomeIcon icon={faCircleXmark} />
            </motion.button>
                <div className='modal-image-container'>
                    <AnimatePresence custom={direction}>
                        <motion.img 
                            src={project.secImg[imageIndex]} 
                            variants={imageSliderVariant}
                            custom={direction}
                            transition={{duration: .2}}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            key={page}/>
                    </AnimatePresence>
                </div>
                <motion.div 
                className='modal-img-desc'
                variants={imageSliderVariant}
                custom={direction}
                transition={{duration: .2}}
                key={page}>
                    <FontAwesomeIcon icon={faQuoteLeft} className="quote-l"/>
                        {createDesc(project.imgDesc[imageIndex])}
                    <FontAwesomeIcon icon={faQuoteRight} className="quote-r"/>
                </motion.div>
                <motion.button onClick={() => prev()} className="prev" whileTap={{scale: .9}}>
                    <FontAwesomeIcon icon={faAngleLeft}/>
                </motion.button>
                <motion.button onClick={() => next()} className="next" whileTap={{scale: .9}}>
                    <FontAwesomeIcon icon={faAngleRight}/>
                </motion.button>
            
            <motion.div className='modal-text-container'>
                <motion.div className='modal-heading'>
                    <motion.h2 variants={textVariantLeft}>{project.title}</motion.h2>
                    <motion.div variants={textVariantRight} className="links">
                        <a href={project.urls.github} 
                        target="_blank" 
                        title="Github" 
                        className='modal-icon'><FontAwesomeIcon icon={faGithub}
                        style={{color: "var(--color-B)"}}/></a>
                        <a href={project.urls.live} 
                        target="_blank"
                        className='modal-icon'><FontAwesomeIcon icon={faGlobe} 
                        style={project.urls.live !== null ? {color: "var(--color-B)"} : ""}
                        title={project.urls.live === null ? "No demo for this :(" : ""}/></a>
                    </motion.div>
                </motion.div>
                {createP(project.description)}
                <motion.div className="project-tech-container right">
                    {project.tech.map((tech, index) => {
                        return(
                            <motion.span 
                            key={index} 
                            className="project-tech"
                            variants={textVariantRight}>{tech}</motion.span>
                        )
                    })}
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default ProjectModal;